import React, { Component } from 'react';
import './LoadingAndPulse.css';
import { PulseLoader } from 'react-spinners';

class LoadingAndPulse extends Component {
  render () {
    const { size, color, whatIsLoading, style } = this.props;
    const message = ' ' + whatIsLoading ? whatIsLoading : ''; // add a space if whatIsLoading prop is passed in
    return (
      <div className="row align-items-center justify-content-center table-container" style={style}>
        <div>
          { message && 
          <div className="loading-text" style={{color: color}}>Loading { message }...</div>
          }
          <div className="row align-items-center justify-content-center">
            <PulseLoader color={ color } size={ size } />
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingAndPulse;
